/* @flow */
import ApolloClient, { createNetworkInterface, createBatchingNetworkInterface } from 'apollo-client';
import Config from 'Config';

import { getCommonHeaders } from 'lib/requestHeaders';

import { detect401, detect503, logNetworkErrors } from 'lib/afterware';

// TODO import from `graphql` package; types don't get included in build
export type GraphQLDocument = {
  definitions: [],
  kind: 'Document'
};

const API_HOST = Config.Environment.R101_API_URL;

// batching borks our mock matching in functional tests
const createInterface = Config.Environment.NODE_ENV === 'functional' ? createNetworkInterface : createBatchingNetworkInterface;

const networkInterface = createInterface({
  uri: `${API_HOST}/graphql`,
  batchInterval: 10,
});

networkInterface.use([{
  applyMiddleware(req, next) {
    req.options.credentials = 'same-origin';

    if (!req.options.headers) {
      req.options.headers = {};  // Create the header object if needed.
    }

    Object.assign(req.options.headers, getCommonHeaders());
    next();
  },
}]);

networkInterface.useAfter([
  detect401,
  detect503,
  logNetworkErrors,
]);

export const apolloClient = new ApolloClient({
  networkInterface,
  dataIdFromObject: (result) => {
    if (result.id && result.__typename) {
      return result.__typename + result.id;
    }
    return null;
  },
});



// WEBPACK FOOTER //
// ./src/lib/graphql.js